require('./bootstrap');

// load bootrap before jQuery
// https://getbootstrap.com/docs/5.2/getting-started/javascript/#optionally-using-jquery
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import $ from 'jquery';
window.$ = window.jQuery = $;

import 'tocbot';

import './handleMenuPosition';
import './catalogue';

// import('./hierarchy-select');
// import('./node_modules/select2');

import { createApp } from 'vue';
import mitt from 'mitt';
// see
// https://github.com/developit/mitt
// https://shouts.dev/articles/data-pass-between-components-using-eventbus-in-vue3
const eventBus = mitt();

let app=createApp({})
app.component('favourite-star-component', require('./components/FavouriteStar.vue').default);
app.component('participate-button-component', require('./components/ParticipateButton.vue').default);
app.component('checkbox-component', require('./components/Checkbox.vue').default);
app.component('communication-preferences-component', require('./components/CommunicationPreferences.vue').default);
app.component('notifications-component', require('./components/Notifications.vue').default);
app.component('notifications-button-component', require('./components/NotificationsButton.vue').default);
app.component('country-select', require('./components/CountrySelect.vue').default);
app.component('country-select-vertical', require('./components/CountrySelectVertical.vue').default);
app.component('emergency-service-type-select', require('./components/EmergencyServiceTypeSelect.vue').default);
app.component('phone-input', require('./components/PhoneInput.vue').default);
app.component('phone-input-vertical', require('./components/PhoneInputVertical.vue').default);
app.component('search-component', require('./components/Search.vue').default);
app.component('user-list-component', require('./components/UserList.vue').default);
app.config.globalProperties.eventBus = eventBus;
app.mount("#app")
